<template>
    <div id="fd-zjxx">
        <MyTitle theTitle="审查信息"/>
            <van-cell-group class="fd-com-scroll">
                <van-cell title="描述">
                    <template v-if="theTable[itemIndex].cSm">
                       <van-field
                           style="padding: 0"
                           v-model="theTable[itemIndex].cSm"
                           readonly
                       ></van-field>
                    </template>
                    <template v-if="theTable[itemIndex].cMs">
                        <van-field
                            style="padding: 0"
                            v-model="theTable[itemIndex].cMs"
                            readonly
                        ></van-field>
                    </template>
                </van-cell>
                <van-field
                    v-model="theTable[itemIndex].shjg"
                    readonly
                    label="审查结果"
                ></van-field>
                <van-field
                    v-model="theTable[itemIndex].dtShrq"
                    readonly
                    label="审查日期"
                ></van-field>
                <van-field
                    v-model="theTable[itemIndex].cShyj"
                    readonly
                    class="fd-textarea"
                    type="textarea"
                    label="审查意见"
                ></van-field>
                <van-cell
                    title="解保裁定书">
                    <div v-for="(item, index) in theTable[itemIndex].cdws"
                           :key="index">
                        <van-field
                            class="fd-textarea"
                            type="textarea"
                            v-model="item.cClmc"
                            readonly
                            style="padding: 0"
                        ></van-field>
                    </div>
                </van-cell>
            </van-cell-group>
    </div>
</template>

<script>
import MyTitle from '../../../components/common/myTitle';
import {mapGetters} from "vuex";
import {zjlxType, typeCclx, typeJcjg, xwsxType, typeJcbqsy} from "@/filters";
import {getXxbqxx, getXxCdws} from "@/api/guarantee";
export default {
    name: "scxxDetail",
    components: {
        MyTitle
    },
    data() {
        return {
            // 获取到的数据需要在mounted中初始化，否则在ie中表格无法自适应
            theTable: null,
            cId: this.$route.query.cId,
            itemIndex: this.$route.query.index,
            // 裁定文书列表
            cdwsList:[],
        };
    },
    computed: {
        ...mapGetters(['xxbqxwxxData', 'xxbqccxsData', 'xxbqzjxxData']),
        tableData() {
            let data = []
            let nBqlx = this.$route.query.nBqlx
            if (nBqlx == '1') {
                this.xxbqccxsData.map((item) => {
                    data.push({
                        // 财产类型
                        type: typeCclx(item.cCclx),
                        // 描述
                        cMs: item.cMs,
                        // 审核结果
                        shjg: typeJcjg(item.cShjg),
                        // 审核日期
                        dtShrq: item.dtShrq.split(' ')[0],
                        // 不通过原因
                        cShyj: item.cShyj,
                        // 解保裁定书
                        cdws: this.cdwsList,

                    })
                })
            } else if (nBqlx == '2') {
                this.xxbqzjxxData.map((item) => {
                    data.push({
                        zjtype: zjlxType(item.nzjlx),
                        cSm: item.cSm, // 证据说明
                        // 审核结果
                        shjg: typeJcjg(item.cshjg),
                        // 审核日期
                        dtShrq: item.dtShrq.split(' ')[0],
                        // 不通过原因
                        cShyj: item.cshyj,
                        // 解保裁定书
                        cdws: this.cdwsList,
                    })

                })
            } else if (nBqlx == '3') {
                this.xxbqxwxxData.map((item) => {
                    data.push({
                        nXwbqsxType: xwsxType(item.nXwbqsx),
                        // 备注
                        cSm: item.cSm,
                        // 审核结果
                        shjg: typeJcjg(item.cshjg),
                        // 审核日期
                        dtShrq: item.dtShrq.split(' ')[0],
                        // 不通过原因
                        cShyj: item.cshyj,
                        // 解保裁定书
                        cdws: this.cdwsList,
                    })
                })
            }
            return data
        },
    },
    watch: {
        tableData(value){
            this.theTable = value;
        }
    },
    methods: {
        getData(){
            getXxbqxx({id: this.cId})
                .then(res => {
                    let nBqlx = this.$route.query.nBqlx
                    console.log('获取基本信息', res.data)
                    res.data.cSqxbyy = typeJcbqsy(res.data.cSqxbyy)
                    res.data.cBz = res.data.cBz ? res.data.cBz : '--';
                    if (nBqlx == 1) {
                        this.$store.dispatch('GetXXBQCCXSList', {xbid:this.cId,bqid:''})
                    } else if (nBqlx == 2) {
                        this.$store.dispatch('GetXXBQZJXXList', {xbid:this.cId,bqid:''})
                    } else if (nBqlx == 3){
                        this.$store.dispatch('GetXXBQXWXXList', {xbid:this.cId,bqid:''})
                    }

                })
                .catch(error => console.log(error))
        },
        // 获取裁定文书
        getCdwsList(){
            getXxCdws({xbid: this.cId}).then((res)=>{
                console.log('res',res)
                this.cdwsList = res.data;
            })
        },

    },
    created() {
        this.getData();
        // 获取裁定文书
        this.getCdwsList();
        this.theTable = this.tableData
    },
    mounted() {

    },
    // 路由跳转之前保存当前滚动条的位置。
    beforeRouteLeave(to, from, next) {
        if (to.name == "continuationPreservationDetail") {
            window.location.reload();
        }
        next();
    },
}
</script>

<style lang="less" scoped>

#fd-zjxx{
    width: 100%;
    height: 100%;
    overflow: hidden;

        .fd-textarea{
            height: auto;
        }

}
</style>
